import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard,
  StickyNote,
  FileText,
  BarChart3,
  MessageSquare,
  Bell,
} from 'lucide-react'
import { cn } from '@/lib/utils'

const mobileNavItems = [
  { to: '/app/dashboard', icon: LayoutDashboard, label: 'Home' },
  { to: '/app/notes', icon: StickyNote, label: 'Notes' },
  { to: '/app/forms', icon: FileText, label: 'Forms' },
  { to: '/app/polls', icon: BarChart3, label: 'Polls' },
  { to: '/app/feedback', icon: MessageSquare, label: 'Feedback' },
  { to: '/app/notifications', icon: Bell, label: 'Alerts' },
]

export function MobileNav() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 flex md:hidden border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      {mobileNavItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            cn(
              'flex flex-1 flex-col items-center gap-1 py-2 text-xs font-medium transition-colors',
              isActive ? 'text-primary' : 'text-muted-foreground',
            )
          }
        >
          <item.icon className="h-5 w-5" />
          {item.label}
        </NavLink>
      ))}
    </nav>
  )
}
